import { UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormInput } from '@microservices/wiskey-react-components'
import { Box, SxProps } from '@mui/material'

import { GENERATOR_INPUT_TYPE } from '@constants'
import { AutocompleteOption } from '@types'

const OPTIONS_AUTOCOMPLETE = [
  { label: 'Other', id: 'other' },
  { label: 'Date', id: 'date' },
]

export const ValueFilterRow = ({
  typeName,
  valueName,
  typeValue,
  sxInput,
  setValue,
}: {
  typeName: string
  valueName: string
  typeValue: AutocompleteOption
  sxInput: SxProps
  setValue: UseFormSetValue<any>
}) => {
  const { t } = useTranslation()

  const handleChangeTypeInputField = () => {
    setValue(valueName, '')
  }

  return (
    <Box sx={{ display: 'flex', flexGrow: 1, gap: '20px', justifyContent: 'space-between' }}>
      <FormInput
        disableClearable
        autocompleteOptions={OPTIONS_AUTOCOMPLETE}
        formInputContainerSx={{ mb: 0.5, width: 'auto' }}
        inputType={GENERATOR_INPUT_TYPE.AUTOCOMPLETE}
        label={t(`label.${valueName}`)}
        labelSx={{ color: 'black' }}
        name={typeName}
        sx={{
          '& .MuiOutlinedInput-root': {
            height: '25px',
            backgroundColor: '#fff',
            width: '100px',
          },
        }}
        onChangeAutocomplete={handleChangeTypeInputField}
      />
      <FormInput
        formInputContainerSx={{ mb: 0.5 }}
        name={valueName}
        sx={sxInput}
        inputType={
          typeValue?.label === 'Other'
            ? GENERATOR_INPUT_TYPE.INPUT
            : GENERATOR_INPUT_TYPE.DATE_TIME_PICKER
        }
      />
    </Box>
  )
}
